const ACCESS_TOKEN_KEY = 'frk.jwt.access';
const REFRESH_TOKEN_KEY = 'frk.jwt.refresh';
const USER_KEY = 'frk.jwt.user';

const getStorage = () => (typeof window !== 'undefined' ? window.sessionStorage : undefined);

type TokenPair = {
  accessToken: string;
  refreshToken?: string | null;
};

export const tokenStorage = {
  read(): TokenPair | null {
    try {
      const storage = getStorage();
      if (!storage) return null;
      const accessToken = storage.getItem(ACCESS_TOKEN_KEY);
      const refreshToken = storage.getItem(REFRESH_TOKEN_KEY);
      if (!accessToken) return null;
      return { accessToken, refreshToken };
    } catch (error) {
      return null;
    }
  },

  write(tokens: TokenPair): void {
    const storage = getStorage();
    if (!storage) return;

    storage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);

    if (tokens.refreshToken) {
      storage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
    } else {
      storage.removeItem(REFRESH_TOKEN_KEY);
    }
  },

  clear(): void {
    const storage = getStorage();
    if (!storage) return;
    storage.removeItem(ACCESS_TOKEN_KEY);
    storage.removeItem(REFRESH_TOKEN_KEY);
    storage.removeItem(USER_KEY);
  },

  writeUser<T>(user: T): void {
    const storage = getStorage();
    if (!storage) return;
    storage.setItem(USER_KEY, JSON.stringify(user));
  },

  readUser<T>(): T | null {
    const storage = getStorage();
    if (!storage) return null;
    const value = storage.getItem(USER_KEY);
    if (!value) return null;
    try {
      return JSON.parse(value) as T;
    } catch (error) {
      return null;
    }
  },
};

export type { TokenPair };
